/**
 * @param {BxTrademarkResponse | KvkVestiging} item
 * @return string
 */
export default function toUrl(item) {
    if (item.handelsnaam) {
        return 'https://www.kvk.nl/zoeken/?source=all&q=' + encodeURI(item.handelsnaam);
    }

    let id = item.id;
    if (!id) {
        return '';
    }
    if (id.startsWith('bx')) {
        return 'https://www.boip.int/embedded-app/trademarks-register?embedded-app-item=' + encodeURI(item.id.substring(2));
    }
    if (id.startsWith('eur')) {
        // Remove EUTM/eur from the number is it present...
        id = id.replace(/\D+/, '');
        return `https://euipo.europa.eu/eSearch/#details/trademarks/${id.padStart(9, '0')}`;
    }
    if (id.startsWith('int')) {
        return 'https://www.wipo.int/madrid/monitor/en/showData.jsp?ROM=1&ID=ROM.' + (id || '')
            .substring(3).replace(/^0+/, '');
    }
    return 'https://www.boip.int/embedded-app/trademarks-register?q=' + encodeURI(item.name);
}
